const CLIENT_ID = process.env.CLIENT_ID || "{clientId}";
const ISSUER =
  process.env.ISSUER || "https://{yourOktaDomain}.com/oauth2/default";
const OKTA_TESTING_DISABLEHTTPSCHECK =
  process.env.OKTA_TESTING_DISABLEHTTPSCHECK || false;
// const BASENAME = import.meta.env.BASE_URL || "";
// BASENAME includes trailing slash
// const REDIRECT_URI = `${window.location.origin}${BASENAME}login/callback`;
const REDIRECT_URI = `${window.location.origin}/callback`;
export default {
  oidc: {
    clientId: CLIENT_ID,
    issuer: ISSUER,
    redirectUri: REDIRECT_URI,
    scopes: ["openid", "profile", "email"],
    pkce: true,
    disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
  },
  resourceServer: {
    messagesUrl: "http://localhost:8000/api/messages",
  },
  // app: {
  //   basename: BASENAME,
  // },
};
